/* eslint-disable no-return-await */

import requesModule from '@/assets/libs/requestModule'
import idxdDB from '@/assets/libs/IndexedDBController'
import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'
import IdentifiedConsumerController from '@/assets/controllers/IdentifiedConsumerController'
import eventModule from '@/assets/libs/eventModule'
import LocaleController from '@/assets/controllers/LocaleController'
import DifferentiatedPricesController from '@/assets/controllers/DifferentiatedPricesController'
let products = []
let productsList = {}
let showOnce = false

let getGeneralInfo = (force = false) => {
    return {...Util.getGeneralInfo(force)}
}
// let timeout = 20 * 60 * 1000
// let makeProdRequest = () => requesModule.postRequest('v3/menu/getByPosExFull', getGeneralInfo(), 'parent', (timeout)).then(r => r && r.data) // menu/getByPosEx
let makeProdRequest = async function (force = false) {
    if (Util.isOracle()) {
        let timeout = 20 * 60 * 1000
        return requesModule.postRequest('v3/menu/getByPosExFull', getGeneralInfo(), 'parent', (timeout)).then(r => r && r.data)
    }
    return await requesModule.postRequest('getcachedfoodmenu', getGeneralInfo(force))
}

let manageDB = async (force = false) => {
    if (Util.getLocalConfigs('urlOdhenInterface') != null) {
        if (window.indexedDB) {
            if (!products.length || force) {
                let db = await idxdDB.getDb()
                products = await idxdDB.getProdSIsFromDb(db)
                products = products && products.length ? products[0] : []

                if (!products.length) {
                    if (Util.getLocalConfigs('hotReload')) {
                        await requesModule.postRequest('purgecache', getGeneralInfo())
                    }
                    return Promise.all([makeProdRequest(force), idxdDB.deleteProdSIFromDb()]).then(values => {
                        values = Util.isOracle() ? values && values[0] : values && values[0] && (values[0].result || (values[0].data && values[0].data.data))
                        if (values) {
                            if (values && values.imgOnlineBaseURL) {
                                Util.setLocalVar('imgOnlineBaseURL', values.imgOnlineBaseURL)
                            }
                            // remove empty groups from menu
                            products = (Util.isOracle() ? values.groups : (JSON.parse(values).data.groups || [])).filter(cat => ((cat.subGroups && cat.subGroups.length > 0) || (cat.products && cat.products.length > 0 && cat.products.length === cat.products.map(p => p.productShowOnMenu === 'N').length)))
                            // products = (JSON.parse(values).data.groups || []).filter(cat => ((cat.subGroups && cat.subGroups.length > 0) || (cat.products && cat.products.length > 0 && cat.products.length === cat.products.map(p => p.productShowOnMenu === 'N').length)))
                            // products = (JSON.parse(values[0].result).data.groups || []).filter(cat => ((cat.subGroups && cat.subGroups.length > 0) || (cat.products && cat.products.length > 0)))
                            products = filterEmptyGroups(products)
                            productsList = Util.generateProdList(products)

                            showOnce = false
                            return idxdDB.addProdSIToDb(products, db).then(() => {
                                Util.updateLastSync()
                                return products
                            })
                        } else {
                            if (!force) {
                                // throw new Error('Não há cardápio cadastrado para este caixa')
                            }
                        }
                    }).catch(e => {
                        if (e && e.message && (showOnce !== e.message)) {
                            let msg = e.message
                            showOnce = msg
                            Util.showInfoModal(msg)
                            Util.setLocalVar('lastSync', 'XI')
                            console.log(e)
                            return manageDB()
                        }
                    })
                }
            }

            if (Object.values(productsList).length === 0) {
                productsList = Util.generateProdList(products)
            }
            products = filterEmptyGroups(products)
            return products
        }
        return makeProdRequest()
    }
    console.error('Odhen Interface url is missing')
    Util.showInfoModal(LocaleController.getString('configuracoes_faltantes_404'))
}

let getProductsFromComanda = async function (comandaNumber, resetCart = true) {
    if (resetCart) {
        CartController.resetCart()
    }
    let requestObject = getGeneralInfo()
    requestObject.saleDescription = comandaNumber
    let retorno = await requesModule.postRequest('sale/getOrderData',
        requestObject,
        'parent').then(r => r).catch((e) => e)
    if (retorno && retorno.error) {
        let msg = retorno.message
        if (Util.isTapMode()) {
            /* setTimeout(() => {
                eventModule.$modal.hideAll()
            }, 3000) */
            eventModule.$emit('restartListenForRfid')
        }
        if (retorno.code !== 'ERR_GET_ORDER_DATA') {
            Util.showInfoModal(msg)
        }
    } else {
        let orderData = (retorno && retorno.data && retorno.data.order) || []
        let comandasAgregadas = CartController.getComandasAgregadas()
        const condition = comandasAgregadas.length === 0 && orderData.consumers != null && orderData.consumers[0].clientCode != null && orderData.consumers[0].consumerCode != null
        if (Boolean(condition) || condition === 0) {
            IdentifiedConsumerController.setConsumerDataComanda(orderData.consumers[0].clientCode, orderData.consumers[0].consumerCode, comandaNumber, orderData.saleCode)
        } else if (comandasAgregadas.length === 0 && orderData.saleCode) {
            IdentifiedConsumerController.setSaleCodeComanda(orderData.saleCode, comandaNumber)
        }
        if (orderData.consumers) {
            IdentifiedConsumerController.setConsumersList(orderData.consumers)
        }
        orderData.items.forEach(item => {
            item.totalItemPrice = item.itemValue || Util.safeDecimalCalc(item.unitValue, item.discount, '-')
            item.unitValue = item.unitValue
            item.observations = item.observations || []
            item.productCombo = item.productCombo || []
            item.comandaNumber = item.comandaNumber || orderData.saleCode
            CartController.addToCart(item)
        })
        CartController.setComanda(orderData)
    }
    return {
        error: retorno.error,
        message: retorno.message,
        code: retorno.code
    }
}

let getProdItem = function (key) {
    if (!(productsList && productsList.length)) {
        return []
    }
    if (key === 'unique') {
        return [...new Map(productsList.map((item) => [(item.productCode || item.subItemCode), item])).values()]
    }
    return key ? productsList.find(p => (p.productCode === key)) : productsList
}

const getGroupName = function (groupCode) {
    return products.find(p => p.groupCode === groupCode).groupName
}

let getBlockProducts = async function () {
    let requestObject = getGeneralInfo()
    return await requesModule.postRequest('v3/menu/getBloqProducts',
        requestObject,
        'parent').then(r => (r && r.data) || []).catch((e) => [])
}

const getProdAvailabilityPerHour = async () => {
    let requestObject = getGeneralInfo()
    return await requesModule.postRequest('menu/getProdAvailabilityPerHour',
        requestObject,
        'parent').then(r => (r && r.data) || []).catch((e) => [])
}

let getComandaPai = function () {
    let comandas = Util.deepCopy(CartController.getComandasAgregadas())
    return comandas && comandas[0]
}

let splitComandas = async function (saleDescription) {
    let requestObject = getGeneralInfo()
    requestObject.saleDescription = saleDescription
    let child = await requesModule.postRequest('sale/getOrderData',
        requestObject,
        'parent').then(r => r).catch((e) => e)
    if (child.error) {
        let msg = child.message
        if (child.code === 'ERR_GET_ORDER_DATA') {
            msg = LocaleController.getString('comanda_nao_encontrada')
        }
        Util.showInfoModal(msg)
        return child.error
    } else {
        let childOrderData = (child && child.data && child.data.order) || []
        requestObject = null
        requestObject = getGeneralInfo()
        requestObject.saleCode = getComandaPai().saleCode
        requestObject.childSaleCode = childOrderData.saleCode

        let retorno = await requesModule.postRequest('sale/splitOrders',
            requestObject,
            'parent').then(r => r).catch((e) => e)
        if (retorno.error) {
            let msg = retorno.message
            Util.showInfoModal(msg)
        } else if (CartController.getMainComandaAgregada().serviceTax !== null) {
            let mainComandaTax = CartController.getMainComandaAgregada().serviceTax
            let subComandaTax = childOrderData.serviceTax
            CartController.getMainComandaAgregada().serviceTax = Util.safeDecimalCalc(mainComandaTax, subComandaTax, '-')
        }
        CartController.filterComanda(childOrderData.saleCode)
        return retorno.error
    }
}

let joinComandas = async function (childSaleDescription) {
    let requestObject = getGeneralInfo()
    requestObject.saleDescription = childSaleDescription
    let retorno = await requesModule.postRequest('sale/getOrderData',
        requestObject,
        'parent').then(r => r).catch((e) => e)
    if (retorno.error) {
        let msg = retorno.message
        if (retorno.code === 'ERR_GET_ORDER_DATA') {
            msg = LocaleController.getString('comanda_nao_encontrada')
        }
        Util.showInfoModal(msg)
        return retorno.error
    }
    let childSaleCode = retorno.data.order.saleCode

    requestObject = {}
    requestObject = getGeneralInfo()
    requestObject.saleCode = getComandaPai().saleCode
    requestObject.childSaleCode = childSaleCode

    retorno = {}
    retorno = await requesModule.postRequest('sale/joinOrders',
        requestObject,
        'parent').then(r => r).catch((e) => e)
    if (retorno.error) {
        let msg = retorno.message
        Util.showInfoModal(msg)
    }
    return retorno.error
}

let addRemoveBloqProducts = async function (code, status) {
    let route = status ? 'menu/addBloqProducts' : 'menu/removeBloqProducts'
    return await requesModule.postRequest(route,
        {
            subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
            storeCode: Util.getGeneralInfo()['storeCode'],
            products: [code]
        },
        'parent').then(r => r)
}

const priceUpdate = function (prod) {
    let isComboProduct = prod.productGroups && prod.productGroups.length > 0
    let printFather = prod.productPrint === 'S'
    // Trata o preco do item principal (pai) ou item simples
    let diffPrice = DifferentiatedPricesController.getDiffPrice(prod.productCode, false, prod)
    if (!isComboProduct || printFather) {
        prod.totalItemPrice = diffPrice ? parseFloat(diffPrice) : parseFloat(prod.price)
        prod.totalItemDiscount = parseFloat(prod.discount)
    } else {
        // Se o produto principal é imprime não, seu preço deve ser zerado
        // (para cálculo do preço total e também para transmitir zerado para a Odhen Interface)
        prod.price = 0
        prod.totalItemPrice = 0
    }

    // Trata o preco das observacoes
    if (prod.observations && prod.observations.length > 0) {
        prod.observations.forEach(o => {
            let multiplier = o.quantity === undefined ? 1 : o.quantity
            prod.totalItemPrice = Math.round((parseFloat(prod.totalItemPrice) + parseFloat((o.price * multiplier) || 0)) * 100) / 100
            prod.totalItemDiscount = Math.round((parseFloat(prod.totalItemDiscount) + parseFloat((o.discount * multiplier) || 0)) * 100) / 100
        })
    }

    if (!isComboProduct) {
        return
    }

    // Trata o preco dos itens filhos
    prod.productCombo.forEach(o => {
        let printChildGroup = ((o.groupPrint === 'S') && printFather)
        let multiplier = o.quantity ? o.quantity : 1
        let fatherProductCode = prod.productCode
        let isFosException = Util.isFosException(o, fatherProductCode, printFather, printChildGroup)
        // let childProductCode = o.productCode || o.subItemCode

        // verifica primeiro os preços do combo do combo
        if (o.choosen) {
            checkComboDoComboPrice(o.choosen, prod, o, printFather)
        }

        /* if ((!printFather && !isFosException) || (printFather && printChildGroup && !isFosException)) {
            if (fatherProductCode === childProductCode) {
                prod.totalItemPrice = Math.round((parseFloat(prod.totalItemPrice) + parseFloat(o.price * multiplier || 0)) * 100) / 100
            }
        } else {
            // Zera o preco dos itens de combo que nao devem ter o preco considerado, para depois transmitir zerado para a Odhen Interface
            o.price = 0
        } */
        if ((!printFather && !isFosException) || (printFather && printChildGroup && !isFosException)) {
            let diffPriceCombo = DifferentiatedPricesController.getDiffPrice((o.subItemCode || o.productCode), true, o) || o.price
            prod.totalItemPrice = Math.round((parseFloat(prod.totalItemPrice) + parseFloat(diffPriceCombo * multiplier || 0)) * 100) / 100
            prod.totalItemDiscount = Math.round((parseFloat(prod.totalItemDiscount) + parseFloat((o.discount * multiplier) || 0)) * 100) / 100
        } else {
            o.price = 0
        }

        // Trata os preços das observações de itens filhos
        if (o.observations && o.observations.length > 0) {
            o.observations.forEach(obs => {
                let obsPrice = obs.price ? obs.price : 0
                let obsMultiplier = obs.quantity ? obs.quantity : 1
                prod.totalItemPrice = Math.round((parseFloat(prod.totalItemPrice) + parseFloat(obsPrice * obsMultiplier * multiplier || 0)) * 100) / 100
                prod.totalItemDiscount = Math.round((parseFloat(prod.totalItemDiscount) + parseFloat((obs.discount * obsMultiplier * multiplier) || 0)) * 100) / 100
            })
        }
    })
}

const checkComboDoComboPrice = function (choosen, prod, group, printFather) {
    // Trata os preços do Combo do Combo
    if (choosen) {
        // let imprimePaiComboDoCombo = choosen.firstLevelFatherPrint === 'S'
        let keys = Object.keys(choosen)
        // No combo do combo o 2 nivel não deve ser cobrado
        /* group.price = 0
        group.fullPrice = 0 */

        if (!printFather) {
            /* Se o item principal é imprime nao, naõ deve cobrar o segundo nivel do combo do combo */
            group.price = 0
            group.fullPrice = 0
        }

        keys.forEach(key => {
            let currentComboComboChilds = choosen[key]

            if (currentComboComboChilds.length > 0) {
                currentComboComboChilds.forEach(child => {
                    let imprimeFilhoComboDoCombo = child.groupPrint === 'S'
                    let multiplier = child.quantity ? child.quantity : 1

                    // if (!printFather || (imprimePaiComboDoCombo && imprimeFilhoComboDoCombo)) {
                    if (!printFather || (printFather && imprimeFilhoComboDoCombo)) {
                        // soma os filhos do combo do combo quando o pai é imprime não ou imprime sim e o filho é imprime sim
                        let diffPriceComboCombo = DifferentiatedPricesController.getDiffPrice((child.subItemCode || child.productCode), true, child) || child.price
                        prod.totalItemPrice = Math.round((parseFloat(prod.totalItemPrice) + parseFloat(diffPriceComboCombo * multiplier || 0)) * 100) / 100
                        prod.totalItemDiscount = Math.round((parseFloat(prod.totalItemDiscount) + parseFloat((child.discount * multiplier) || 0)) * 100) / 100
                    } else {
                        // Zera o preco dos itens de combo que nao devem ter o preco considerado, para depois transmitir zerado para a Odhen Interface
                        child.price = 0
                    }
                    // Trata os preços das observações do combo do combo
                    if (child.observations && child.observations.length > 0) {
                        child.observations.forEach(obs => {
                            let obsPrice = obs.price ? obs.price : 0
                            let obsMultiplier = obs.quantity ? obs.quantity : 1
                            prod.totalItemPrice = Math.round((parseFloat(prod.totalItemPrice) + parseFloat(obsPrice * obsMultiplier * multiplier || 0)) * 100) / 100
                            prod.totalItemDiscount = Math.round((parseFloat(prod.totalItemDiscount) + parseFloat((obs.discount * obsMultiplier * multiplier) || 0)) * 100) / 100
                        })
                    }
                })
            }
        })
    }
}

const filterEmptyGroups = function (products) {
    return (products || []).filter(product => {
        if (product.idShowTaa === 'N') {
            return false
        }
        // Verifica se tem produtos válidos no grupo principal
        if (product.products && product.products.length > 0) {
            let productsFiltered = Util.removeBlockedProds(product.products)
            if (productsFiltered.length > 0) {
                return true
            }
        }

        // Verifica se tem subgrupos com produtos válidos
        if (product.subGroups && product.subGroups.length > 0) {
            return product.subGroups.some(subGroup => {
                if (subGroup.products && subGroup.products.length > 0) {
                    let subGroupProductsFiltered = Util.removeBlockedProds(subGroup.products)
                    return subGroupProductsFiltered.length > 0
                }
                return false
            })
        }

        return false
    })
}

export default {
    addRemoveBloqProducts,
    getProductsFromComanda,
    splitComandas,
    joinComandas,
    getProducts: async (force = false) => {
        showOnce = false
        return await manageDB(force)
    },
    getBlockProducts,
    getProdAvailabilityPerHour,
    getProductObservations: function (productCode) {
        let requestObject = getGeneralInfo()
        requestObject.productCode = productCode
        return requesModule.postRequest('menu/getProductObservations',
            requestObject,
            'parent').then(r => r && r.data)
    },
    getProductCombos: function (productCode) {
        let requestObject = getGeneralInfo()
        requestObject.productCode = productCode
        return requesModule.postRequest('menu/getProductCombos',
            requestObject,
            'parent').then(r => r && r.data)
    },
    getProdItem,
    priceUpdate,
    setProductsList: (productsUpdated, productsListUpdated) => {
        products = productsUpdated
        productsList = productsListUpdated
    },
    getGroupName
}



// WEBPACK FOOTER //
// ./src/assets/controllers/ProductController.js